export default __webpack_public_path__ + "static/media/logo-challenges.ba77e5b6.svg";